import { useFetchedPromptVariables } from '../../growegy-ai/variables/hooks/useFetchedPromptVariables';
import { VariableBox } from '../../growegy-ai/variables/components/VariableBox';
import { VARIABLE_COMPANY, VARIABLE_METADATAS } from '../../growegy-ai/types';
import { getOrCreateVariableViewModel } from '../../growegy-ai/util';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';
import { useFetchedBillingCustomer } from '../../billing/hooks/useFetchedBillingCustomer';

export const SurveyVariables = () => {
  useAnalyticsPage(Page.BUSINESS_PLAN_VARIABLES);
  const {
    query: { data: variables },
    queryStatusComponent: variablesStatusComponent,
  } = useFetchedPromptVariables();
  const {
    query: { data: customer },
    queryStatusComponent: customerStatusComponent,
  } = useFetchedBillingCustomer();

  return (
    <div className="business-plan-variables__container">
      {customer ? (
        <div className="variables-table__name-header growegy-font20--weight500 growegy-font-em">
          {customer.name}
        </div>
      ) : (
        customerStatusComponent
      )}
      <div className="business-plan-variables__note">
        Provide essential details about your business which enables our AI to help you complete
        later sections.
      </div>
      {!variables
        ? variablesStatusComponent
        : VARIABLE_METADATAS.filter((x) => x.isRequiredForBusinessPlan).map((x, i) => {
            const variable = getOrCreateVariableViewModel(variables, x, i);
            return (
              <VariableBox
                key={variable.variableValue.name}
                item={variable}
                showName={!variable.hideName}
                hideNameValue={variable.variableValue.name === VARIABLE_COMPANY}
              />
            );
          })}
    </div>
  );
};
